import HttpClient from './client';
import type { ResponseError } from './types/responseErrorTypes';

export default HttpClient;
export type { ResponseError };
